import { RouteDictionary } from '@deltek/specification-client/core/Models/routeTypes'
import ContactDetailsPage from 'pages/ContactsPage/ContactDetailsPage'
import ContactsPageHome from 'pages/ContactsPage/ContactsPageHome'

export const ContactsPageRoutes: RouteDictionary = {
    '/': {
        redirect: '/home',
    },
    '/home': {
        name: 'Home',
        component: ContactsPageHome,
    },
    '/details': {
        name: 'Detail',
        component: ContactDetailsPage,
    },
    '/details/:id': {
        name: 'Detail',
        component: ContactDetailsPage,
    },
}
